import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const ADMIN_LOGOUT = 'ADMIN_LOGOUT';
export const ADMIN_LOGOUT_SUCCESS = 'ADMIN_LOGOUT_SUCCESS';
export const ADMIN_LOGOUT_FAILURE = 'ADMIN_LOGOUT_FAILURE';

// Action Creators
export const getAdminLogout = () => ({
  type: ADMIN_LOGOUT,
});

export const getAdminLogoutSuccess = (users) => ({
  type: ADMIN_LOGOUT_SUCCESS,
  payload: users,
});

export const getAdminLogoutFailure = (error) => ({
  type: ADMIN_LOGOUT_FAILURE,
  payload: error,
});

// Thunk Function
export const adminLogout = (body, external) => {
  return async (dispatch) => {
    dispatch(getAdminLogout());
    try {
      const response = await postMethodWithToken(url.adminLogout, body);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getAdminLogoutSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getAdminLogoutFailure('error?.message'));
      }
    } catch (error) {
      dispatch(getAdminLogoutFailure(error?.message));
      if (external?.error === true) {
        external?.handleErrorFunction(error);
      }
    }
  };
};
